import processesApi from "../../api/processesApi";

const state = { processes: [] };

const actions = {
    createProcess({ commit }, process) {
        return new Promise((resolve, reject) => {
            processesApi
                .store(process)
                .then((response) => {
                    if (response.status === 201) {
                        commit("ADD_PROCESS", response.data.processCreated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getProcesses({ commit }) {
        return new Promise((resolve, reject) => {
            processesApi
                .all()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_PROCESS", response.data.processes);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    updateProcess({ commit }, data) {
        return new Promise((resolve, reject) => {
            processesApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_PROCESS", response.data.processUpdated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getDocuments(context, processId) {
        return new Promise((resolve, reject) => {
            processesApi
                .getDocuments(processId)
                .then((response) => {
                    if (response.status === 200) {
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteDocumentFromProcess(context, data) {
        return new Promise((resolve, reject) => {
            processesApi
                .deleteDocumentFromProcess(data)
                .then((response) => {
                    if (response.status === 200) {
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    async updateProcessStatus({ commit }, processId) {
        return new Promise((resolve, reject) => {
            processesApi
                .updateProcessStatus(processId)
                .then((response) => {
                    if (response.status === 200) {
                        commit;
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        })

    },

    deleteProcess({ commit }, processId) {
        return new Promise((resolve, reject) => {
            processesApi
                .delete(processId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_PROCESS", processId);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    ADD_PROCESS: (state, process) => state.processes.unshift(process),
    SET_PROCESS: (state, processes) => (state.processes = processes),
    UPDATE_PROCESS: (state, process) => {
        const index = state.processes.findIndex(
            (process) => process.id === process.id
        );
        if (index !== -1) {
            state.processes.splice(index, 1, process);
        }
    },
    DELETE_PROCESS: (state, processID) => {
        state.processes = state.processes.filter(
            (process) => process.id !== processID
        );
    },
};
export default { state, actions, mutations };